<template>
<v-container fluid>

  <!-- FILTRO -->
  <v-row class="mb-4">
    <v-col cols="12" sm="4">
      <v-select
        v-model="filtroRequerimientos"
        :items="filtrosRequerimientos"
        item-text="text"
        item-value="value"
        label="Filtrar requerimientos"
        dense
        outlined
      />
    </v-col>
  </v-row>

  <v-row
    v-if="esAdmin"
    class="mb-4"
  >

    <v-col cols="12" md="3">
      <v-select
        v-model="filtrosAdmin.proveedor"
        :items="listaProveedores"
        label="Proveedor"
        clearable
        dense
        outlined
      />
    </v-col>

    <v-col cols="12" md="3">
      <v-select
        v-model="filtrosAdmin.contratista"
        :items="listaContratistas"
        label="Contratista"
        clearable
        dense
        outlined
      />
    </v-col>

    <v-col cols="12" md="3">
      <v-select
        v-model="filtrosAdmin.estado"
        :items="listarEstados"
        label="Estado"
        clearable
        dense
        outlined
      />
    </v-col>

    <v-col cols="12" md="3">
      <v-text-field
        v-model="filtrosAdmin.nrorequerimiento"
        label="N° Requerimiento"
        clearable
        dense
        outlined
        prepend-inner-icon="mdi-magnify"
      />
    </v-col>

  </v-row>
  <v-row class="mb-4">
    <v-btn
      v-if="esAdmin"
      class="ma-2 white--text"
      color="green darken-2"
      @click="descargarReporteAdjudicacion()"
    >
      <v-icon left>mdi-file-excel</v-icon>
      Exportar seguimiento
    </v-btn>
  </v-row>
  <!-- CONTADOR -->
  <v-chip small color="primary" class="mb-2">
    {{ requerimientosFiltrados.length }} requerimientos visibles
  </v-chip>

  <!-- REQUERIMIENTOS -->
  <div
    v-for="(reque, index) in requerimientosFiltrados"
    :key="reque.idrequerimiento"
    class="requerimiento-card"
    :class="{
      'card-alt': index % 2 === 1,
      'req-cerrado': reque.estado === 'CERRADO'
    }"
  >

    <!-- HEADER -->
    <div class="req-header">

      <div>

        <div class="req-title">
          <strong>{{ reque.denominacion.slice(0,3) }}</strong>
          <span class="grey--text">
            - {{ reque.empresa_contacto }}
          </span>

          <v-chip x-small class="ml-1">
            {{ reque.nombre_categoria }}
          </v-chip>
        </div>

        <div class="req-subtitle">
          {{ detallesTextoServicio(reque.detalles) }} ({{ detallesTexto(reque.detalles) }})
          <v-icon small class="ml-2">mdi-calendar</v-icon>
          {{ formatearFecha(reque.fecha_inicio) }}
        </div>

        <!-- <v-chip
          v-if="reque.postulaciones && reque.postulaciones.length > 0"
          small
          color="green lighten-4"
          text-color="green darken-2"
          class="ml-2"
        >
          {{ reque.postulaciones.length }} postulantes
        </v-chip>

        <v-chip
          v-else
          small
          color="grey lighten-3"
          text-color="grey darken-2"
          class="ml-2"
        >
          Sin postulantes
        </v-chip> -->
        <v-chip
          v-if="!reque.postulaciones || reque.postulaciones.length === 0"
          small
          color="grey lighten-3"
          text-color="grey darken-2"
          class="ml-2"
        >
          Sin postulantes
        </v-chip>

      </div>

      <v-chip
        small
        :color="reque.estado === 'ABIERTO' ? 'green' : 'grey'"
        text-color="white"
      >
        {{ reque.estado }}
      </v-chip>
    </div>
    <div class="action-group">
      <v-btn
        v-if="esAdmin"
        class="ma-2 white--text"
        color="light-blue darken-4"
        @click="descargarReporte(reque.idrequerimiento)"
      >
        <v-icon left>mdi-folder-multiple-plus-outline</v-icon
        >Exportar
      </v-btn>
      <v-btn
        small
        color="blue"
        outlined
        @click="enprocesoRequerimiento(reque.idrequerimiento)"
      >
        <v-icon left small>mdi-lock</v-icon>
        EN_PROCESO
      </v-btn>
      <v-btn
        v-if="reque.estado !== 'CERRADO' && reque.estado !== 'ANULADO'"
        small
        color="red"
        outlined
        @click="abrirCerrarRequerimiento(reque)"
      >
        <v-icon left small>mdi-lock</v-icon>
        Cerrar requerimiento
      </v-btn>
      <v-btn
        v-if="esAdmin"
        small
        color="orange"
        outlined
        @click="regularizarRequerimiento(reque.idrequerimiento)"
      >
        <v-icon left small>mdi-lock</v-icon>
        Regularizar
      </v-btn>
      <v-btn
        v-if="esAdmin && reque.estado !== 'CERRADO' && reque.estado !== 'ANULADO'"
        small
        color="red"
        outlined
        @click="anularRequerimiento(reque)"
      >
        <v-icon left small>mdi-cancel</v-icon>
        Anular requerimiento
      </v-btn>
      <v-btn
        small
        color="deep-orange"
        outlined
        :disabled="!reque.puedeCerrarSinAdjudicacion"
        @click="cerrarSinAdjudicar(reque.idrequerimiento)"
      >
        <v-icon left small>
          mdi-lock-outline
        </v-icon>
        Cerrar sin adjudicar
      </v-btn>
    </div>

    <!-- TABLA EMPRESAS -->
    <v-card-text>

      <div class="d-flex align-center mb-3">

        <v-btn
          icon
          small
          @click="
            toggleRequerimiento(
              reque.idrequerimiento
            )
          "
        >
          <v-icon>

            {{
            requerimientosExpandido.includes(
              reque.idrequerimiento
            )
            ? 'mdi-chevron-down'
            : 'mdi-chevron-right'
            }}

          </v-icon>
        </v-btn>

        <v-chip
          small
          color="indigo lighten-4"
        >
          {{
            postulacionesVisibles(
              reque.postulaciones
            ).length
          }}
          empresas postuladas
        </v-chip>

      </div>

      <v-expand-transition>

        <v-simple-table
          v-if="
            requerimientosExpandido.includes(
              reque.idrequerimiento
            )
          "
        >

        <thead>
          <tr>
            <th width="40"></th>
            <th>Empresa</th>
            <th>RUC</th>
            <th>Contacto</th>
            <th>Correo</th>
            <th>Estado</th>
            <th class="text-right">Acciones</th>
          </tr>
        </thead>

        <tbody>

          <template
            v-for="post in postulacionesVisibles(reque.postulaciones)"
          >

            <!-- FILA PRINCIPAL -->
            <tr :key="post.idpostulacion">

              <!-- FLECHA HISTORIAL -->
              <td>

                <v-btn
                  v-if="post.evaluaciones && post.evaluaciones.length > 0"
                  icon
                  x-small
                  @click="toggleHistorial(post.idpostulacion)"
                >
                  <v-icon small>
                    {{
                      historialAbierto.includes(post.idpostulacion)
                      ? 'mdi-chevron-down'
                      : 'mdi-chevron-right'
                    }}
                  </v-icon>
                </v-btn>

                <v-chip
                  v-if="post.evaluaciones"
                  x-small
                  class="ml-1"
                >
                  {{ post.evaluaciones.length }}
                </v-chip>

              </td>

              <td>
                {{ post.empresa.razonsocial }}
              </td>

              <td>
                {{ post.empresa.ruc }}
              </td>

              <td>
                {{ formatearCelulares(post.empresa.representante_cel) }}
              </td>

              <td>

                <v-chip
                  v-for="(mail,i) in separarCorreos(post.empresa.correo)"
                  :key="i"
                  small
                  class="mr-1"
                  color="blue lighten-4"
                >
                  <v-icon left small>mdi-email</v-icon>
                  {{ mail }}
                </v-chip>

              </td>

              <td>

                <v-chip
                  small
                  :color="colorEstado(post.estado)"
                  text-color="white"
                >
                  {{ post.estado }}
                </v-chip>

              </td>

              <!-- BOTONES -->
              <td class="text-right">

                <v-btn
                  icon
                  @click="verEmpresa(post.empresa, reque.idrequerimiento, post.idpostulacion)"
                >
                  <v-icon>mdi-eye</v-icon>
                </v-btn>

                <!-- <v-btn
                  icon
                  color="primary"
                  @click="abrirEvaluacion(reque, post)"
                >
                  <v-icon>mdi-clipboard-check</v-icon>
                </v-btn> -->

                <v-btn
                  icon
                  color="primary"
                  @click="abrirEvaluacion(reque, post)"
                >
                  <v-icon>mdi-plus-circle</v-icon>
                </v-btn>

              </td>

            </tr>

            <!-- HISTORIAL -->
            <tr
              v-if="
                historialAbierto.includes(post.idpostulacion) &&
                post.evaluaciones &&
                post.evaluaciones.length > 0
              "
            >

              <td colspan="7">

                <v-card flat class="pa-3 grey lighten-4">

                  <div class="text-subtitle-2 mb-2">
                    Historial de evaluaciones
                  </div>

                  <v-alert
                    dense
                    outlined
                    color="success"
                    class="mb-3"
                  >

                    Estado actual:

                    <strong>

                      {{ post.evaluaciones[0].estado }}

                    </strong>

                  </v-alert>

                  <v-timeline dense>

                    <v-timeline-item
                      v-for="(ev,index) in post.evaluaciones"
                      :key="ev.idevaluacion"
                      small
                      :color="index===0 ? 'success' : colorEstado(ev.estado)"
                    >

                      <v-card
                        flat
                        :class="index===0
                          ? 'pa-2 green lighten-5 rounded-lg'
                          : 'pa-2'"
                      >

                        <div class="d-flex align-center">

                          <div class="text-caption font-weight-bold">

                            {{ ev.estado }}

                          </div>

                          <v-chip
                            v-if="index===0"
                            x-small
                            color="success"
                            text-color="white"
                            class="ml-2"
                          >
                            ACTUAL
                          </v-chip>

                        </div>

                        <div
                          v-if="ev.descripcion_tipo_respuesta"
                          class="text-caption grey--text"
                        >
                          {{ ev.descripcion_tipo_respuesta }}
                        </div>

                        <div
                          v-if="ev.comentario"
                          class="text-caption"
                        >
                          {{ ev.comentario }}
                        </div>

                        <div class="text-caption grey--text">

                          {{ formatearFecha(ev.fecha) }}

                          <template v-if="esAdmin">

                            <v-icon small class="ml-2">
                              mdi-clock-outline
                            </v-icon>

                            {{ formatearHora(ev.fecha) }}

                          </template>

                        </div>

                      </v-card>

                    </v-timeline-item>
                  </v-timeline>

                </v-card>

              </td>

            </tr>

          </template>

          <tr v-if="!reque.postulaciones || reque.postulaciones.length === 0">
            <td colspan="7" class="text-center grey--text">
              No hay empresas postuladas
            </td>
          </tr>

        </tbody>

      </v-simple-table>

    </v-expand-transition>

  </v-card-text>

  </div>
  <v-dialog v-model="modalEmpresa" max-width="900" persistent>
      <v-card v-if="empresaDetalle" class="empresa-card">

        <!-- HEADER -->
        <v-card-title class="empresa-header">
          <div>
            <div class="empresa-title">
              {{ empresaDetalle.razonsocial }}
            </div>
            <div class="empresa-subtitle">
              RUC: {{ empresaDetalle.ruc }}
            </div>
          </div>

          <v-btn
            icon
            class="btn-close"
            @click="modalEmpresa = false"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>

        <!-- BODY -->
        <v-card-text v-if="empresaDetalle" class="empresa-body">
          <v-row dense>

            <!-- DATOS GENERALES -->
            <v-col cols="12">
              <div class="section-title">Datos generales</div>
            </v-col>

            <v-col cols="6">
              <span class="label">Nombre comercial</span>
              <div class="value">{{ empresaDetalle.nombre_comercial || '—' }}</div>
            </v-col>

            <v-col cols="12">
              <div class="section-title">Representante</div>
            </v-col>

            <v-col cols="6">
              <span class="label">Nombre</span>
              <div class="value">{{ empresaDetalle.representante || '—' }}</div>
            </v-col>

            <v-col cols="6">
              <span class="label">Celular</span>
              <div class="value">{{ empresaDetalle.representante_cel || '—' }}</div>
            </v-col>

            <v-col cols="12">
              <span class="label">Correo</span>
              <div class="value">{{ empresaDetalle.correo || '—' }}</div>
            </v-col>

          </v-row>
        </v-card-text>

        <!-- FOOTER -->
        <v-card-actions class="empresa-footer">
          <v-spacer />

          <v-btn
            color="primary"
            class="btn-cerrar"
            @click="modalEmpresa = false"
          >
            <v-icon left>mdi-check</v-icon>
            Cerrar
          </v-btn>
        </v-card-actions>

      </v-card>
    </v-dialog>

    <!-- ================= MODAL EVALUAR ================= -->
    <v-dialog v-model="modalEvaluar" max-width="600">
      <v-card>
        <v-card-title>
          Evaluar empresa
        </v-card-title>

        <v-card-text v-if="evaluacion && evaluacion.empresa">
          <div class="mb-3">
            <strong>{{ evaluacion.empresa.razon_social }}</strong><br>
            <small class="grey--text">
              RUC: {{ evaluacion.empresa.ruc }}
            </small>
          </div>

          <v-select
            label="Estado"
            :items="estados"
            v-model="evaluacion.estado"
          />

          <v-select
            label="Tipo de respuesta"
            :items="tiposRespuesta"
            item-text="descripcion"
            item-value="id_tipo_respuesta"
            v-model="evaluacion.id_tipo_respuesta"
            @change="asignarPuntaje"
          />

          <v-text-field
            label="Código de Respuesta"
            type="number"
            v-model="evaluacion.puntaje"
          />

          <v-textarea
            label="Comentario"
            v-model="evaluacion.comentario_empresa"
          />
        </v-card-text>

        <v-card-actions class="justify-end">
          <v-btn text @click="modalEvaluar = false">
            Cancelar
          </v-btn>

          <v-btn color="primary" @click="guardarEvaluacion">
            Guardar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
        v-model="dialogCerrar"
        max-width="500"
        persistent
    >

      <v-card>

        <v-card-title>
          Cerrar requerimiento
        </v-card-title>

        <v-card-text>

        <!-- <v-row>
            <strong>{{ requerimientoCerrar.denominacion.slice(0,3) }}</strong>
            <span class="grey--text">
              - {{ requerimientoCerrar.empresa_contacto }}
            </span>

            <v-chip x-small class="ml-1">
              {{ requerimientoCerrar.nombre_categoria }}
            </v-chip>
          </div>

          <div class="req-subtitle">
            {{ detallesTextoServicio(requerimientoCerrar.detalles) }} ({{ detallesTexto(requerimientoCerrar.detalles) }})
            <v-icon small class="ml-2">mdi-calendar</v-icon>
            {{ formatearFecha(requerimientoCerrar.fecha_inicio) }}
          </div>

        </v-row> -->  

        <p class="mb-4">
        Debe ingresar las siguientes fechas del requerimiento.
        </p>

        <v-text-field
            v-model="fechaInicioRequerimiento"
            label="Fecha inicio"
            type="date"
            required
        ></v-text-field>

        <v-text-field
            v-model="fechaFinRequerimiento"
            label="Fecha fin"
            type="date"
            required
        ></v-text-field>

        </v-card-text>

        <v-card-actions>

        <v-spacer></v-spacer>

        <v-btn
        text
        @click="dialogCerrar=false"
        >
        Cancelar
        </v-btn>

        <v-btn
        color="primary"
        @click="cerrarRequerimiento"
        >
        Cerrar requerimiento
        </v-btn>

        </v-card-actions>

      </v-card>

    </v-dialog>

</v-container>
</template>

<script>
import axios from 'axios'

export default {
  name: 'MisRequerimientos',

  data () {
    return {
      requerimientos: [],

      modalEvaluar: false,
      evaluacion: null,
      modalEmpresa: false,
      empresaDetalle: null,
      historialAbierto:[],

      estados: [
        'OBSERVADO',
        'ADJUDICADO',
        'NO_ADJUDICADO'
      ],

      tiposRespuesta: [],

      filtroRequerimientos: 'CON_ABIERTOS', // 👈 por defecto

      filtrosRequerimientos: [
        { text: 'Con postulaciones (abiertos)', value: 'CON_ABIERTOS' },
        { text: 'Sin postulaciones (abiertos)', value: 'SIN_ABIERTOS' },
        { text: 'Solo cerrados', value: 'CERRADOS' },
        { text: 'Todos', value: 'TODOS' }
      ],

      filtrosAdmin: {
        proveedor: null,
        contratista: null,
        estado: null,
        nrorequerimiento: null,
      },

      requerimientosExpandido: [],

      esAdmin: false,

      dialogCerrar: false,
      idRequerimientoCerrar: null,

      fechaInicioRequerimiento: null,
      fechaFinRequerimiento: null,
      requerimientoCerrar: {
          denominacion: '',
          empresa_contacto: '',
          nombre_categoria: '',
          detalles: [],
          fecha_inicio: null
      },
    }
  },
  created(){
    this.idusuario = localStorage.getItem('idusuario')
    this.rol = localStorage.getItem('rol')
    this.empresaid = localStorage.getItem('empresa')
    this.empresaid = this.empresaid ? Number(this.empresaid) : null
    this.idcontratista = localStorage.getItem('empresacontratista')
    this.idcontratista = this.idcontratista ? Number(this.idcontratista) : null
    this.esAdmin =
    this.rol === 'ADMINISTRADOR'
  },
  mounted () {
    this.listarRequerimientos()
    this.listarRespuestas()
  },

  computed: {
    requerimientosFiltrados () {

      return this.requerimientos.filter(reque => {

        const postulaciones = reque.postulaciones || []

        const validas = postulaciones.filter(p =>
          p.estado !== 'RECHAZADO_ADMIN' &&
          p.estado !== 'REGISTRADO'
        )

        /*
        ==========================
        FILTROS ADMIN
        ==========================
        */

        if(this.esAdmin){

          if (this.filtrosAdmin.estado) {

            const existeEstado =
              validas.some(
                p =>
                  p.estado ===
                  this.filtrosAdmin.estado
              )

            if (!existeEstado) {
              return false
            }

          }

          if(
            this.filtrosAdmin.contratista &&
            reque.empresa_contacto !==
            this.filtrosAdmin.contratista
          ){
            return false
          }

          if (this.filtrosAdmin.proveedor) {

            const existeProveedor =
              validas.some(p => {

                const nombreProveedor =
                  p.empresa?.razonsocial ||
                  p.empresa?.razon_social

                return (
                  nombreProveedor ===
                  this.filtrosAdmin.proveedor
                )

              })

            if (!existeProveedor) {
              return false
            }

          }
          if (this.filtrosAdmin.nrorequerimiento) {

            const nroRequerimiento =
              reque.denominacion?.split('-')[0]?.trim()
              // o reque.denominacion?.slice(0,3)

            if (
              !nroRequerimiento?.includes(
                this.filtrosAdmin.nrorequerimiento.trim()
              )
            ) {
              return false
            }

          }

        }

        /*
        ==========================
        FILTRO ORIGINAL
        ==========================
        */

        if (this.filtroRequerimientos === 'CERRADOS') {
          return reque.estado === 'CERRADO'
        }

        if (this.filtroRequerimientos === 'TODOS') {
          return true
        }

        if (reque.estado === 'CERRADO') {
          return false
        }

        if (this.filtroRequerimientos === 'CON_ABIERTOS') {
          return validas.length > 0
        }

        if (this.filtroRequerimientos === 'SIN_ABIERTOS') {
          return validas.length === 0
        }

        return true

      })
      .sort((a,b)=>
        new Date(b.fecha_inicio) -
        new Date(a.fecha_inicio)
      )

    },
    listaProveedores() {

      return [...new Set(

        this.requerimientos.flatMap(r =>

          this.postulacionesVisibles(
            r.postulaciones
          ).map(p =>

            p.empresa?.razonsocial ||
            p.empresa?.razon_social

          )

        )

      )]
      .filter(Boolean)
      .sort()

    },

    listaContratistas() {

      return [...new Set(
        this.requerimientos.map(
          r => r.empresa_contacto
        )
      )]

    },

    listarEstados() {

      return [...new Set(
        this.requerimientos.flatMap(r =>
          (r.postulaciones || []).map(
            p => p.estado
          )
        )
      )]

    },
  },

  methods: {
    listarRequerimientos () {
      axios.get(`api/Requerimientos/ListarPorContra/${this.idusuario}`)
        .then(res => {
          this.requerimientos = res.data
          this.requerimientos = (res.data || []).map(reque => ({
            ...reque,
            puedeCerrarSinAdjudicacion:
              this.calcularPuedeCerrarSinAdjudicacion(reque)
          }))
        })
        .catch(err => {
          console.error(err)
        })
    },
    listarRespuestas () {
      axios.get('api/PostulacionEmpresas/ListarRespuestaPostulacion')
        .then(res => {
          this.tiposRespuesta = res.data
        })
        .catch(err => {
          console.error(err)
        })
    },
    abrirEvaluacion (reque, post) {
      // this.evaluacion = {
      //   idpostulacion: post.idpostulacion,
      //   idrequerimiento: reque.idrequerimiento,
      //   idempresa: post.idempresa,
      //   estado: post.estado,
      //   id_tipo_respuesta: post.id_tipo_respuesta,
      //   puntaje: post.puntaje ?? null,
      //   comentario_empresa: post.comentario_empresa,
      //   empresa: post.empresa
      // }
      this.evaluacion = {
        idpostulacion: post.idpostulacion,
        idrequerimiento: reque.idrequerimiento,
        idempresa: post.idempresa,

        // 🔥 limpio para nueva evaluación
        estado: null,
        id_tipo_respuesta: null,
        puntaje: null,
        comentario_empresa: null,

        empresa: post.empresa
      }

      this.modalEvaluar = true
    },

    guardarEvaluacion () {
      const payload = {
        idpostulacion: this.evaluacion.idpostulacion,
        idrequerimiento: this.evaluacion.idrequerimiento,
        id_empresa: this.evaluacion.idempresa,
        estado: this.evaluacion.estado,
        id_tipo_respuesta: this.evaluacion.id_tipo_respuesta || null,
        puntaje:
          this.evaluacion.puntaje === '' ||
          this.evaluacion.puntaje === undefined
            ? null
            : Number(this.evaluacion.puntaje),
        comentario: this.evaluacion.comentario_empresa || null
      }
      axios.put('api/PostulacionEmpresas/Actualizar', payload)
        .then(() => {
          this.modalEvaluar = false
          this.listarRequerimientos()
        })
        .catch(() => {
          alert('Error al guardar evaluación')
        })
    },

    verEmpresa (empresa, idreq, idpos) {
      this.empresaDetalle = empresa
      this.modalEmpresa = true
      if (!this.esAdmin) {
        axios
          .put('/api/PostulacionEmpresas/Actualizar', {
            idpostulacion: idpos,
            idrequerimiento: idreq,
            id_empresa: empresa.idempresa,
            estado: 'EN_EVALUACIÓN',
          })
          .then(() => {
            this.showConfirm = true;
          })
          .catch(error => {
            console.log(error.response)
          })
      }
    },

    colorEstado (estado) {
      switch (estado) {
        case 'REGISTRADO': return 'teal'
        case 'ADJUDICADO': return 'green'
        case 'RECHAZADO':
        case 'RECHAZADO':
        case 'NO_ADJUDICADO': return 'red'
        case 'OBSERVADO':
        case 'EN_POSTULACION': return 'orange'
        case 'EN_EVALUACION':
        case 'EN_EVALUACIÓN': return 'blue'
        default: return 'grey'
      }
    },

    asignarPuntaje (valor) {
      this.evaluacion.puntaje = valor
    },
    postulacionesVisibles (lista) {
      if (!lista) return []

      if (this.esAdmin) return lista

      return lista.filter(p => {
        const evaluaciones = p.evaluaciones || []

        const fueRechazadaAdmin = evaluaciones.some(ev =>
          ev.estado === 'RECHAZADO' &&
          ev.id_tipo_respuesta == null
        )

        const estaEnPostulacion = evaluaciones.some(ev =>
          ev.estado === 'EN_POSTULACION'
        )

        return (
          p.estado !== 'REGISTRADO' &&
          !fueRechazadaAdmin &&
          estaEnPostulacion
        )
      })
      // return lista.filter(p =>
      //   p.estado !== 'REGISTRADO' &&
      //   p.estado !== 'RECHAZADO_ADMIN'
      // )
    },
    formatearCelulares(cel) {
      if (!cel) return ''

      return cel
        .toString()
        .trim()
        .split(/[\s,;]+/)   // separa por espacio, coma o ;
        .join(' / ')
    },
    separarCorreos(correos) {
      if (!correos) return []
      return correos.toString().trim().split(/[\s,;]+/)
    },
    async cerrarRequerimiento(idrequerimiento) {
      // if (!confirm('¿Deseas cerrar este requerimiento?')) return

      // // const idrequerimiento = this.requerimientoSeleccionado.idrequerimiento

      // axios.post(`/api/PostulacionEmpresas/Cerrar/${idrequerimiento}`)
      // .then(() => {
      //   alert("El requerimiento fue cerrado correctamente")
      //   this.listarRequerimientos()
      // })
      // .catch(error => {
      //   console.log(error.response)
      //   alert("Error al cerrar el requerimiento")
      // })
      if (!this.fechaInicioRequerimiento) {
        alert("Debe ingresar la fecha de inicio.");
        return;
      }

      if (!this.fechaFinRequerimiento) {
        alert("Debe ingresar la fecha de fin.");
        return;
      }

      if (this.fechaFinRequerimiento < this.fechaInicioRequerimiento) {
        alert("La fecha fin no puede ser menor que la fecha inicio.");
        return;
      }

      try {

        await axios.post(
          `/api/PostulacionEmpresas/Cerrar/${this.idRequerimientoCerrar}`,
          {
            fechaInicio: this.fechaInicioRequerimiento,
            fechaFin: this.fechaFinRequerimiento
          }
        );

        this.dialogCerrar = false;

        alert("El requerimiento fue cerrado correctamente.");

        this.listarRequerimientos();

      }
      catch(error){

        console.log(error.response);

        alert("Error al cerrar el requerimiento");

      }
    },
    regularizarRequerimiento(idrequerimiento) {
      if (!confirm('¿Deseas regularizar y cerrar este requerimiento?')) return

      // const idrequerimiento = this.requerimientoSeleccionado.idrequerimiento

      axios.post(`/api/PostulacionEmpresas/Regularizar/${idrequerimiento}`)
      .then(() => {
        alert("El requerimiento fue regularizado y cerrado correctamente")
        this.listarRequerimientos()
      })
      .catch(error => {
        console.log(error.response)
        alert("Error al regularizar y cerrar el requerimiento")
      })
    },
    enprocesoRequerimiento(idrequerimiento) {
      if (!confirm('¿Deseas cambiar a EN PROCESO a este requerimiento?')) return

      // const idrequerimiento = this.requerimientoSeleccionado.idrequerimiento

      axios.post(`/api/PostulacionEmpresas/EnProceso/${idrequerimiento}`)
      .then(() => {
        alert("El requerimiento fue cambiado correctamente")
        this.listarRequerimientos()
      })
      .catch(error => {
        console.log(error.response)
        alert("Error cambiar el requerimiento")
      })
    },
    toggleHistorial(id){

      const index = this.historialAbierto.indexOf(id)

      if(index > -1){
        this.historialAbierto.splice(index,1)
      }else{
        this.historialAbierto.push(id)
      }

    },

    formatearFecha(fecha){
      if(!fecha) return ''
      return new Date(fecha).toLocaleDateString()
    },
    formatearHora(fecha){
      if(!fecha) return ''
      return new Date(fecha)
      .toLocaleTimeString(
        'es-PE',
        {
          hour12:false,
          hour:'2-digit',
          minute:'2-digit',
          second:'2-digit'
        }
      )
    },
    detallesTexto(detalles) {
      if (!detalles || !detalles.length) return ''
      return detalles.map(d => d.detalle).join(', ')
    },
    detallesTextoServicio(detalles) {
      if (!detalles || !detalles.length) return ''
      return detalles.map(d => d.servicio).join(', ')
    },
    toggleRequerimiento(id) {

      if (
        this.requerimientosExpandido.includes(id)
      ) {

        this.requerimientosExpandido =
          this.requerimientosExpandido.filter(
            x => x !== id
          )

      } else {

        this.requerimientosExpandido.push(id)

      }
    },
    async descargarReporte(id_requerimiento) {

      this.downloadLoading = true
      try {
        const response = await axios.post(
          '/api/FiltrosContratos/ExportarSeguimientoReq',
          { id_req: id_requerimiento },
          { responseType: 'blob' } // importante para descargar binario
        )

        // const url = window.URL.createObjectURL(new Blob([response.data]))
        // const link = document.createElement('a')
        // link.href = url
        // console.log(this.rubro_tipo_s)
        // const rubro = this.rubro_tipo_s.find(
        //   r => r.id === this.rubro_tipo_servicio
        // );
        // console.log(rubro)
        // const nombre = rubro ? rubro.nombrecategoria : '';
        // console.log(nombre)
        // const nombreArchivo =
        //   `${this.zfill(this.requerimientoid, 3)}_RRQ_` +
        //   `${this.empresa_contratista}_` +
        //   `${nombre}_` +
        //   `${this.fechaActual()}.xlsx`;
        // link.setAttribute('download', nombreArchivo)
        // document.body.appendChild(link)
        // link.click()
        // document.body.removeChild(link)
        const blob = new Blob([response.data])
        const contentDisposition = response.headers['content-disposition']
        let fileName = 'archivo.xlsx'
        if (contentDisposition) {
          const utf8Match = contentDisposition.match(/filename\*=UTF-8''([^;]+)/i)

          if (utf8Match) {
            fileName = decodeURIComponent(utf8Match[1])
          } else {
            const normalMatch = contentDisposition.match(/filename="?([^"]+)"?/i)

            if (normalMatch) {
              fileName = normalMatch[1]
            }
          }
        }

        const urlBlob = window.URL.createObjectURL(blob)
        const link = document.createElement('a')
        link.href = urlBlob
        link.setAttribute('download', fileName)
        document.body.appendChild(link)
        link.click()
        link.remove()

      } catch (error) {
        console.error('Error al exportar Excel', error)
      } finally {
        this.downloadLoading = false
      }
    },
    abrirCerrarRequerimiento(item) {
      this.idRequerimientoCerrar = item.idrequerimiento;
      this.requerimientoCerrar = item;
      this.fechaInicioRequerimiento =
          item.fecha_inicio.split('T')[0] || null;
      this.fechaFinRequerimiento =
          item.fecha_fin.split('T')[0] || null;
      this.dialogCerrar = true;
    },
    anularRequerimiento(idrequerimiento) {
      if (!confirm('¿Deseas anular este requerimiento?')) return

      axios.post(
        `/api/PostulacionEmpresas/Anular/${idrequerimiento}`
      )
      .then(() => {
        alert('El requerimiento fue anulado correctamente')
        this.listarRequerimientos()
      })
      .catch(error => {
        console.log(error.response)
        alert('Error al anular el requerimiento')
      })
    },
    calcularPuedeCerrarSinAdjudicacion (reque) {
      const postulaciones = reque.postulaciones || []

      if (!postulaciones.length) {
        return false
      }

      // Si existe un adjudicado,
      // ya no corresponde cerrar sin adjudicar
      const tieneAdjudicado = postulaciones.some(
        p => p.estado === 'ADJUDICADO'
      )

      if (tieneAdjudicado) {
        return false
      }

      // Todas las postulaciones deben tener respuesta final
      return postulaciones.every(p =>
        p.estado === 'RECHAZADO' ||
        p.estado === 'NO_ADJUDICADO'
      )
    },
    puedeCerrarSinAdjudicacion (reque) {
      if (!reque) return false

      if (
        reque.estado === 'CERRADO' ||
        reque.estado === 'ANULADO'
      ) {
        return false
      }

      const postulaciones = reque.postulaciones || []

      if (!postulaciones.length) {
        return false
      }

      // No debe existir ningún adjudicado
      const existeAdjudicado = postulaciones.some(
        p => p.estado === 'ADJUDICADO'
      )

      if (existeAdjudicado) {
        return false
      }

      // Todos deben tener una respuesta final
      return postulaciones.every(post => {

        const evaluaciones = post.evaluaciones || []

        if (!evaluaciones.length) {
          return false
        }

        const ultima = evaluaciones[0]

        return (
          ultima.estado === 'NO_ADJUDICADO' ||
          ultima.estado === 'RECHAZADO'
        )
      })
    },
    async cerrarSinAdjudicar (idrequerimiento) {
      if (
        !confirm(
          '¿Deseas cerrar este requerimiento sin adjudicar ninguna empresa?'
        )
      ) {
        return
      }

      try {

        await axios.post(
          `/api/PostulacionEmpresas/CerrarSinAdjudicar/${idrequerimiento}`
        )

        alert(
          'El requerimiento fue cerrado sin adjudicación correctamente'
        )

        await this.listarRequerimientos()

      } catch (error) {

        console.log(error.response)

        alert(
          error.response?.data ||
          'Error al cerrar el requerimiento sin adjudicación'
        )
      }
    },
    async descargarReporteAdjudicacion () {
      this.downloadLoading = true

      try {
        const response = await axios.post(
          '/api/FiltrosContratos/ExportarSeguimientoContratistas',
          {},
          {
            responseType: 'blob'
          }
        )

        const blob = new Blob(
          [response.data],
          {
            type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
          }
        )

        const contentDisposition =
          response.headers['content-disposition']

        let fileName = 'seguimiento_contratista.xlsx'

        if (contentDisposition) {
          const utf8Match =
            contentDisposition.match(
              /filename\*=UTF-8''([^;]+)/i
            )

          if (utf8Match) {
            fileName = decodeURIComponent(
              utf8Match[1]
            )
          } else {
            const normalMatch =
              contentDisposition.match(
                /filename="?([^"]+)"?/i
              )

            if (normalMatch) {
              fileName = normalMatch[1]
            }
          }
        }

        const urlBlob =
          window.URL.createObjectURL(blob)

        const link =
          document.createElement('a')

        link.href = urlBlob
        link.setAttribute(
          'download',
          fileName
        )

        document.body.appendChild(link)

        link.click()

        link.remove()

        window.URL.revokeObjectURL(urlBlob)

      } catch (error) {
        console.error(
          'Error al exportar seguimiento contratista',
          error
        )

        alert(
          'Error al generar el reporte'
        )

      } finally {
        this.downloadLoading = false
      }
    },
  },
  watch: {
    'evaluacion.id_tipo_respuesta'(nuevoValor){

      if(!this.evaluacion) return

      this.evaluacion.puntaje = nuevoValor

    }
  }

}
</script>

<style scoped>
.req-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
}

.req-title {
  font-size: 18px;
  font-weight: 700;
}

.req-subtitle {
  font-size: 14px;
  color: #6b7280;
}

.btn-close {
  color: #6b7280;
}

.empresa-body {
  font-size: 14px;
}

.section-title {
  font-weight: 600;
  font-size: 14px;
  color: #374151;
  border-bottom: 1px solid #e5e7eb;
  padding-bottom: 4px;
  margin: 12px 0 8px;
}

.label {
  font-size: 12px;
  color: #6b7280;
}

.value {
  font-size: 14px;
  color: #111827;
}

.empresa-footer {
  background: #fafafa;
  border-top: 1px solid #e0e0e0;
}

.btn-cerrar {
  border-radius: 20px;
  padding: 0 20px;
  font-weight: 500;
}
.requerimiento-card {
  background: #ffffff;
  border-radius: 14px;
  padding: 20px 24px;
  margin-bottom: 28px;
  box-shadow: 0 6px 18px rgba(0,0,0,.08);
  transition: all .2s ease;
  position: relative;
}

/* alternado */
.card-alt {
  background: #f8fafc;
  border-left: 6px solid #cbd5f5;
}
.requerimiento-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 10px 26px rgba(0,0,0,.12);
}
.req-cerrado {
  opacity: .6;
  border-left: 4px solid #9ca3af;
}
.expand-chip{
  cursor:pointer;
}
</style>
